import React from 'react';
import Svg, { Path } from 'react-native-svg';

const ShieldCheckIcon = ({ size = 18, color = '#109648' }: { size?: number, color?: string }) => (
    <Svg width={size} height={size} viewBox="0 0 12 14" fill="none">
        <Path
            d="M5.316 7.783L3.999 6.466a.499.499 0 00-.366-.15.499.499 0 00-.367.15c-.1.1-.15.222-.15.367 0 .144.05.266.15.366l1.65 1.65c.1.1.22.15.358.15a.49.49 0 00.359-.15l3.083-3.083a.473.473 0 00.133-.35.473.473 0 00-.133-.35.463.463 0 00-.342-.133.463.463 0 00-.341.133L5.316 7.783zm.683 5.833a.879.879 0 01-.125-.008.615.615 0 01-.108-.025c-1.489-.445-2.711-1.358-3.667-2.742C1.144 9.458.666 7.938.666 6.283V3.016a.97.97 0 01.183-.575c.123-.172.278-.297.467-.375L5.649.45c.123-.044.24-.066.35-.066.111 0 .228.022.35.066l4.334 1.617c.189.078.344.203.466.375a.97.97 0 01.184.575v3.267c0 1.655-.478 3.175-1.434 4.558-.955 1.384-2.177 2.297-3.666 2.742l-.234.033zm0-1c1.278-.422 2.32-1.22 3.125-2.391.806-1.173 1.209-2.487 1.209-3.942V3.016L5.999 1.383 1.666 3.016v3.267c0 1.455.403 2.77 1.208 3.942.806 1.172 1.848 1.969 3.125 2.391z"
            fill={color}
        />
    </Svg>
);

export default ShieldCheckIcon;
